var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Autocomplete, Box, Button, Grid, TextField, Typography, } from "@mui/material";
import { styled } from "@mui/material/styles";
import { X } from "@phosphor-icons/react";
import React, { useEffect, useRef, useState, } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ContractApi from "../../../infrastructure/api/pages/contract-api";
import CustomModal from "../modal/CustomModal";
const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
});
const SignedDocumentModal = ({ open, onClose, leadId, refresh, setRefreshModalData, setActionTabRefresh, setObjectModal, setStatusSectionRefresh, }) => {
    const [contractOptions, setContractOptions] = useState([]);
    const [error, setError] = useState(undefined);
    const [disable, setDisable] = useState(true);
    const personSelectRef = useRef(null);
    const [saving, setSaving] = useState(false);
    const { t: translate } = useTranslation();
    const [files, setFiles] = useState([]);
    const [selected, setSelected] = useState(null);
    const [contractContactPersonEmailDetail, setContractContactPersonEmailDetail,] = useState([]);
    // Constants
    const MAX_FILE_SIZE_MB = 3.5;
    const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // 3.5 MB in bytes
    // Compute `disable` state dynamically based on selected contract and uploaded files
    const isSaveDisabled = !selected || (selected && disable) || files.length === 0;
    /**
     * Validates and handles file selection with size restrictions
     */
    const handleFileChange = (event) => {
        if (event.target.files) {
            const selectedFiles = Array.from(event.target.files);
            const validFiles = [];
            const rejectedFiles = [];
            // Validate each file
            selectedFiles.forEach((file) => {
                if (file.size > MAX_FILE_SIZE_BYTES) {
                    const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
                    rejectedFiles.push(`${file.name} (${fileSizeMB} MB)`);
                }
                else {
                    validFiles.push(file);
                }
            });
            // Show error for rejected files
            if (rejectedFiles.length > 0) {
                const rejectedList = rejectedFiles.join(", ");
                toast.error(`${translate("FileSizeExceeded")}: ${rejectedList}.`);
            }
            // Add valid files to state
            if (validFiles.length > 0) {
                setFiles((prevFiles) => [...prevFiles, ...validFiles]);
                // Show success message for valid files
                if (rejectedFiles.length > 0) {
                    toast.success(`${validFiles.length} ${translate("FileAddedSuccessfully")}`);
                }
            }
            // Reset input to allow re-selecting the same file
            event.target.value = "";
        }
    };
    /**
     * Removes a file from the upload list
     */
    const handleDeleteNewDocment = (indexToRemove) => {
        if (indexToRemove !== undefined) {
            setFiles((prevFiles) => prevFiles.filter((_, index) => index !== indexToRemove));
        }
    };
    /**
     * Formats file size for display
     */
    const formatFileSize = (bytes) => {
        if (bytes < 1024)
            return `${bytes} bytes`;
        if (bytes < 1024 * 1024)
            return `${(bytes / 1024).toFixed(2)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    };
    //   const [refresh,setRefresh]=useState<boolean>(false);
    useEffect(() => {
        if (leadId) {
            ContractApi.GetContractContactPersonEmailDetailByLeadId(leadId)
                .then((response) => {
                if (response.status === 200 && response.data != null) {
                    setContractContactPersonEmailDetail(response.data);
                }
            })
                .finally(() => { });
        }
    }, [leadId, refresh]);
    useEffect(() => {
        if (leadId) {
            ContractApi.getActiveContractByLeadIdDropDown(leadId)
                .then((response) => {
                if (response.status === 200 && response.data != null) {
                    const op = response.data.map((item) => {
                        return {
                            id: item.value,
                            label: item.text,
                            // map other properties if needed
                        };
                    });
                    setContractOptions(op);
                }
            })
                .finally(() => { });
        }
    }, [leadId, refresh]);
    const handleAutocompleteChange = (event, newValue) => {
        setSelected(newValue);
        if (!newValue) {
            setDisable(true);
            setError("Verplicht");
        }
        else {
            const responseMessage = checkIfEmailNotNull(newValue === null || newValue === void 0 ? void 0 : newValue.id);
            if (!responseMessage) {
                setDisable(false);
            }
            else {
                toast.warning(responseMessage);
                setDisable(true);
            }
            setError(undefined);
        }
    };
    const checkIfEmailNotNull = (id) => {
        const response = contractContactPersonEmailDetail.find((item) => item.contractId === id);
        return response === null || response === void 0 ? void 0 : response.message;
    };
    const handleSaveButtonClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (selected && files.length > 0) {
            setSaving(true);
            // setDisable(true);
            const formData = new FormData();
            files.forEach((file) => formData.append("files", file));
            formData.append("contractId", selected.id);
            yield ContractApi.uploadSignedDocumentData(formData)
                .then((response) => {
                if (response.status === 200 && response.data != null) {
                    toast.success(translate("UploadedSuccessfully"));
                    setRefreshModalData((prev) => !prev);
                    setActionTabRefresh((prev) => !prev);
                    setObjectModal((prev) => !prev);
                    setStatusSectionRefresh((prev) => !prev);
                }
            })
                .finally(() => {
                onCloseModal();
                setSaving(false);
                // setDisable(false);
            });
        }
    });
    const onCloseModal = () => {
        setSelected(null);
        setFiles([]);
        setError(undefined);
        onClose();
    };
    return (_jsx(CustomModal, { open: open, onClose: onCloseModal, size: "sm", saving: saving, handleSaveButtonClick: handleSaveButtonClick, heading: translate("Upload Signed Document"), saveButtonText: translate("DocumentUpload"), disabled: isSaveDisabled, children: _jsx(Box, { sx: {
                marginTop: "1%",
                padding: "16px 32px",
                borderRadius: "24px",
            }, children: _jsx(Grid, { container: true, spacing: 0, children: _jsxs(Grid, { size: {
                        lg: 8,
                        xs: 12
                    }, sx: {
                        mx: "auto"
                    }, children: [_jsx(Autocomplete, { disablePortal: true, id: "combo-box-demo", options: contractOptions, onChange: handleAutocompleteChange, noOptionsText: translate("noOptions"), sx: { width: 300, marginBottom: "5%" }, renderInput: (params) => (_jsx(TextField, Object.assign({}, params, { label: translate("Select Contract"), error: !!error, helperText: error, inputRef: personSelectRef }))) }), _jsxs(Button, { component: "label", variant: "contained", tabIndex: -1, sx: { marginBottom: "5%" }, startIcon: _jsx(CloudUploadIcon, {}), children: [translate("UploadFiles"), _jsx(VisuallyHiddenInput, { type: "file", onChange: handleFileChange, multiple: true })] }), _jsxs(Typography, { variant: "caption", color: "textSecondary", sx: {
                                display: "block",
                                mb: 2
                            }, children: [translate("MaxFileSize"), ": ", MAX_FILE_SIZE_MB, " MB"] }), files &&
                            (files === null || files === void 0 ? void 0 : files.map((file, index) => (_jsxs(Grid, { className: "selected-file", children: [_jsxs(Typography, { variant: "body2", children: [file.name, " (", formatFileSize(file.size), ")"] }), _jsx(X, { size: 16, onClick: () => {
                                            handleDeleteNewDocment(index);
                                        }, cursor: "pointer" })] }, `${file.name}-${index}`))))] }) }) }) }));
};
export default SignedDocumentModal;
